import type {FC} from "react";

import {Link} from "react-router";

import AdminButton from "../AdminButton";
import LogoutButton from "../LogoutButton";

/**
 * Application header component.
 */
export const AppHeader: FC = () => (
  <div style={{position: 'relative'}}>
    <img alt='' src='images/header-bg_2.svg' className='HEADER_BGR center'
         style={{width: '100%'}}/>
    <Link to='/'>
      <img src='images/hydrolink_w.svg'
           style={{position: 'absolute', top: '20px', left: '50%', width: '14%', marginLeft: '-7%'}} alt=''/>
    </Link>
    <div className='header-actions'>
      <AdminButton/>
      <LogoutButton/>
    </div>
  </div>
)
